import { type FC } from 'react';
import PhotoHeart from 'dibs-interiors-photos/exports/PhotoHeart.tsx';
import PhotoOverlayItem from 'dibs-interiors-photos/exports/PhotoOverlayItem.tsx';
import SocialDropdown from 'dibs-interiors-photos/exports/SocialDropdown.ts';
import { trackSavePhoto } from 'dibs-interiors-photos/exports/trackingHelpers.ts';
import { graphql, useFragment } from 'react-relay';
import { useServerVars } from '../shared/ServerVarsContext.tsx';
import { usePhotoLikesContext } from './PhotoLikesContext.tsx';

import { type ProjectPhotoLikeWrapper_tradePhoto$key } from './__generated__/ProjectPhotoLikeWrapper_tradePhoto.graphql.ts';

import styles from './ProjectPhotoLikeWrapper.scss';

type Props = {
    tradePhoto: ProjectPhotoLikeWrapper_tradePhoto$key | null | undefined;
};

const ProjectPhotoLikeWrapper: FC<Props> = ({ tradePhoto: tradePhotoRef }) => {
    const tradePhoto = useFragment(
        graphql`
            fragment ProjectPhotoLikeWrapper_tradePhoto on TradePhoto {
                id
                url
                serviceId
            }
        `,
        tradePhotoRef
    );

    const photoNodeId = tradePhoto?.id || '';
    const photoId = tradePhoto?.serviceId || '';

    const photoLikesMap = usePhotoLikesContext();
    const { photoLikeId, totalPhotoLikes } = (photoLikesMap && photoLikesMap.get(photoId)) || {};

    const onPhotoLikeAdded = (): void => {
        trackSavePhoto({ label: 'project' });
    };

    const { isMobile } = useServerVars();

    if (isMobile) {
        return (
            <PhotoOverlayItem>
                <div className={styles.dropdownWrapper}>
                    <SocialDropdown
                        photoNodeId={photoNodeId}
                        photoLikeId={photoLikeId}
                        photoId={photoId}
                        onPhotoLikeAdded={onPhotoLikeAdded}
                        photoUrl={tradePhoto?.url || ''}
                    />
                </div>
            </PhotoOverlayItem>
        );
    } else {
        return (
            <div className={styles.overlay}>
                <PhotoOverlayItem>
                    <div className={styles.iconsWrapper}>
                        {photoLikesMap !== null && (
                            <PhotoHeart
                                photoNodeId={photoNodeId}
                                photoLikeId={photoLikeId}
                                photoId={photoId}
                                onPhotoLikeAdded={onPhotoLikeAdded}
                                totalPhotoLikes={totalPhotoLikes}
                            />
                        )}
                    </div>
                </PhotoOverlayItem>
            </div>
        );
    }
};

export default ProjectPhotoLikeWrapper;
